/**
 * Minimal procedural sound. A real "thwip" without any audio assets:
 * a quick descending saw-tooth blip synthesised with the Web Audio API.
 */
export class AudioEngine {
  private context: AudioContext | null = null;

  /** Must be called from a user gesture (e.g. clicking "Play"). */
  resume(): void {
    if (!this.context) {
      try {
        this.context = new AudioContext();
      } catch {
        this.context = null;
      }
    }
    void this.context?.resume();
  }

  thwip(): void {
    const ctx = this.context;
    if (!ctx) return;
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(900, t);
    osc.frequency.exponentialRampToValueAtTime(180, t + 0.12);
    gain.gain.setValueAtTime(0.18, t);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.15);
  }
}
